export default __webpack_public_path__ + "static/media/IconExcel.d5ac06e9.svg";